/*************************************************

* BAKER HUGHES COMPANY CONFIDENTIAL

* Unpublished work copyright 2025 Baker Hughes Company.  All rights reserved.

*

* This computer code is proprietary and highly confidential to Baker Hughes Company

* and/or its affiliate(s). It may not be used, disclosed, modified, transferred,

* or reproduced without prior written consent, and must be returned on demand.

**************************************************/

import { SvgIcon, SvgIconProps } from '@material-ui/core';

const MenuCloseIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 9C5 8.44772 5.44772 8 6 8H26C26.5523 8 27 8.44772 27 9C27 9.55228 26.5523 10 26 10H6C5.44772 10 5 9.55228 5 9ZM5 16C5 15.4477 5.44772 15 6 15H14C14.5523 15 15 15.4477 15 16C15 16.5523 14.5523 17 14 17H6C5.44772 17 5 16.5523 5 16ZM6 22C5.44772 22 5 22.4477 5 23C5 23.5523 5.44772 24 6 24H20C20.5523 24 21 23.5523 21 23C21 22.4477 20.5523 22 20 22H6Z"
      fill="white"
    />
  </SvgIcon>
);

export default MenuCloseIcon;
